import React, { useRef, useState } from 'react';
import { Calendar, Trophy, MapPin, Play, Pause, Volume2, VolumeX, Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { siteInfo } from '../data/mock';

export default function Hero() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(true);
  const [muted, setMuted] = useState(true);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) { videoRef.current.play(); setPlaying(true); }
    else { videoRef.current.pause(); setPlaying(false); }
  };
  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setMuted(videoRef.current.muted);
  };

  return (
    <section className="relative min-h-[88vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          poster={siteInfo.heroImage}
          className="w-full h-full object-cover"
        >
          <source src={siteInfo.heroVideo} type="video/mp4" />
        </video>
        <div className="absolute inset-0 hero-gradient"></div>
      </div>

      <div className="absolute bottom-6 right-6 z-20 flex gap-2">
        <button onClick={togglePlay} className="w-10 h-10 rounded-full bg-black/50 backdrop-blur border border-white/20 text-white flex items-center justify-center hover:bg-pink-brand transition-colors" aria-label={playing ? 'Pausa' : 'Riproduci'}>
          {playing ? <Pause size={16} /> : <Play size={16} />}
        </button>
        <button onClick={toggleMute} className="w-10 h-10 rounded-full bg-black/50 backdrop-blur border border-white/20 text-white flex items-center justify-center hover:bg-pink-brand transition-colors" aria-label={muted ? 'Audio on' : 'Audio off'}>
          {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
        </button>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 lg:px-8 w-full py-16 text-center lg:text-left">
        <div className="inline-flex items-center gap-2 bg-pink-brand/25 border border-pink-brand rounded-full px-4 py-2 mb-5">
          <Trophy size={16} className="text-pink-brand" />
          <span className="text-white text-sm font-semibold uppercase tracking-wider">
            {siteInfo.edition}
          </span>
        </div>

        <h1 className="font-brand text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-none mb-3">
          “{siteInfo.title}”
        </h1>
        <p className="font-display text-lg md:text-xl uppercase text-white/85 tracking-widest mb-8">
          Memorial {siteInfo.subtitle}
        </p>

        <div className="flex flex-wrap items-center gap-5 mb-9 justify-center lg:justify-start">
          <div className="flex items-center gap-3">
            <Calendar size={22} className="text-pink-brand" />
            <span className="text-white font-semibold text-base lg:text-lg">{siteInfo.dateRange}</span>
          </div>
          <div className="hidden md:block w-px h-6 bg-white/20"></div>
          <div className="flex items-center gap-3">
            <MapPin size={20} className="text-pink-brand" />
            <span className="text-white font-semibold text-base lg:text-lg">Cava de&rsquo; Tirreni</span>
          </div>
        </div>

        <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
          <Link to="/calendario" className="btn-primary">
            <Calendar size={18} /> Calendario
          </Link>
          <Link to="/squadre" className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-white text-white font-bold hover:bg-white hover:text-navy transition-colors">
            <Trophy size={18} /> Squadre
          </Link>
          <a
            href={siteInfo.brochurePdf}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-white/15 border border-white/30 text-white font-bold hover:bg-white/25 transition-colors"
          >
            <Download size={18} /> Brochure
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-navy to-transparent z-10"></div>
    </section>
  );
}
